export default __webpack_public_path__ + "static/media/asset-detail-iv-audio.c0eb81aa.png";